"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pickers = require("@material-ui/pickers");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateElement = function DateElement(_ref) {
  var item = _ref.item;

  var handleDateChange = function handleDateChange(date) {
    // setSelectedDate(date);
    return date;
  };

  console.log("ESTILOS DateElement field: ", item);
  var defaultStyles = {};
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  console.log("ESTILOS DateElement style: ", style);
  return /*#__PURE__*/React.createElement(_pickers.KeyboardDatePicker, {
    id: item.name,
    label: item.attributes.label,
    format: "DD/MM/YYYY",
    value: "",
    onChange: handleDateChange,
    cancelLabel: "Cancelar",
    helperText: item.attributes.placeholder,
    error: false,
    readOnly: true,
    disabled: true,
    style: style,
    KeyboardButtonProps: {
      "aria-label": "cambiar fecha"
    }
  });
};

var _default = DateElement;
exports.default = _default;